import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { ReleaseService } from '../_services/release.service';
import { InfoIconComponent } from '../_directives/info-icon/info-icon.component';
import { environment } from '../../environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-release-history',
  templateUrl: './release-history.component.html',
  styleUrls: ['./release-history.component.scss']
})
export class ReleaseHistoryComponent implements OnInit {

  sortOrder: any = "desc";
  searchKey: any;
  numberOfRelease: any;
  tableData: any;
  openIframe: boolean = false;
  latestDate: any;
  componentRef: any;
  modalRef: NgbModalRef;
  docUrl: any;
  helpdocFullView: boolean;
  @Output() close = new EventEmitter();

  public searchReleaseTimer: any = 0;
  public searchReleaseSubscription: any;

  constructor(public releaseService: ReleaseService, 
    public container: ViewContainerRef, public resolver: ComponentFactoryResolver,
    private _userService: UserService,
    private modalService: NgbModal,private sanitizer:DomSanitizer) { }

  ngOnInit() {
    this._userService.loadUserInfo()
    this.callListApi();
    setTimeout(() => {
      this.latestDate = this.tableData[0].release_date ? this.tableData[0].release_date : '';
    },250)
    
  }

  // Function for sorting
  onClickSort() {
    if(this.sortOrder == 'asc') {
      this.sortOrder = 'desc';
      this.callListApi('dsc');
    } else if(this.sortOrder == 'desc') {
      this.sortOrder = 'asc';
      this.callListApi('asc');
    }
  }

  // Formatting date
  formatDate(date) {
    let d = date.split(' ')
    return(d[0]);
  }

  // Common function for API call
  callListApi(sortOrder='dsc') {
    this.releaseService.releaseHistoryList(sortOrder, this.searchKey).subscribe(
      (result: any) => {
        this.tableData = result.result;
        this.latestDate = this.tableData[0].release_date ? this.tableData[0].release_date : '';
        // Setting no. of releases
        this.numberOfRelease = `${result.result.length} ${result.result.length==1 ? 'Release' : 'Releases'}`;
      }, error => {
        console.log(error);
      }
    )
  }

  // Search function
  searchReleaseData() {
      clearTimeout(this.searchReleaseTimer);
      this.searchReleaseTimer = setTimeout(() => {
        if(this.searchReleaseSubscription) {
          this.searchReleaseSubscription.unsubscribe();
        }
        this.searchReleaseSubscription = this.callListApi();
      }, 600)
  }

  // Function to open CiraPlatform
  openCiraPlatform() {
    let url = `${environment.base_url}`;
    window.open(url, "_self");
  }

  //Function to open Helpdoc component
  openHelpInfo(){
    const factory = this.resolver.resolveComponentFactory(
      InfoIconComponent
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.autoTrigger = true;
  }
  open(content, item) {
    this.docUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(item.release_url)
    this.modalRef = this.modalService.open(content, { size: 'lg',windowClass: 'help-guide-modal'});
  }

  maximizeHelpDoc(){
    this.helpdocFullView = !this.helpdocFullView;
    const element = document.querySelector(".help-guide-modal");
    if(this.helpdocFullView){
      element.classList.add("max-help-guide-modal");
    }else{
      element.classList.remove("max-help-guide-modal");
    }
  }
  closeHelpBlock(){
    this.close.emit(true);
  }
}
